import { Card, CardContent, Stack, Typography } from '@mui/material'
import { FunctionComponent, ReactNode } from 'react'
import { Link } from 'react-router-dom'

export const ReportingOverviewCard: FunctionComponent<{
  title: string, description: string, image?: string, iconNode?: ReactNode, clickHandler?: () => void, link?: string, height: string, width: string,
}> = ({ title, description, image, iconNode, clickHandler, link, height, width
}) => {
    const visual = (
      <Stack alignItems='center' justifyContent='center' sx={{ height }}>
        {iconNode
          ? iconNode
          : (image ? <img src={image} alt={title} style={{ maxWidth: width, maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} /> : null)}
      </Stack>
    )
    return (
      <>
        {!link &&
          <Card onClick={clickHandler} sx={{
            height: '100%', boxShadow: 'none', borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', pt: 3, pl: 3, pr: 3, cursor: 'pointer'
          }}>
            <CardContent sx={{ height: '100%' }}>
              <Stack>
                <Stack alignItems='center' justifyContent='center' sx={{margin: 'auto'}}>
                  {visual}
                </Stack>
                <Stack sx={{ pt: 5, pb: 3 }}>
                  <Typography variant='subtitle1' sx={{ fontWeight: 600, color: 'text.primary', pb: 1 }}>
                    {title}
                  </Typography>
                  <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                    {description}
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>}
        {link &&
          <Card sx={{
            height: '100%', boxShadow: 'none', borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', pt: 3, pl: 3, pr: 3, cursor: 'pointer'
          }}>
            <Link to={link} style={{ textDecoration: 'none' }}>
              <CardContent sx={{ height: '100%', position: 'relative' }}>
                <Stack>
                  <Stack alignItems='center' justifyContent='center' sx={{ margin: 'auto' }}>
                    {visual}
                  </Stack>
                  <Stack sx={{ pt: 5, pb: 3 }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, color: 'text.primary', pb: 1 }}>
                      {title}
                    </Typography>
                    <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                      {description}
                    </Typography>
                  </Stack>
                </Stack>
              </CardContent>
            </Link>
          </Card>}
      </>
    )
  }